var _title;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgStarEmpty = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 28 26.74"
}, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "star empty2")), /*#__PURE__*/React.createElement("path", {
  d: "M6,27.41l1.07-8.49L1.22,12.64a.85.85,0,0,1,.44-1.41l8.4-1.68L14.22,2a.91.91,0,0,1,1.5,0l4.16,7.52,8.4,1.68a.81.81,0,0,1,.44,1.41l-5.84,6.28,1.06,8.49a.86.86,0,0,1-1.23.88L15,24.67,7.23,28.29A.89.89,0,0,1,6,27.41ZM21.2,18.74a1,1,0,0,1,.27-.71l5-5.48-7.34-1.41c-.18-.09-.44-.18-.53-.45L15,4.15l-3.62,6.54a1.16,1.16,0,0,1-.62.45L3.43,12.55l5,5.48a.76.76,0,0,1,.27.71l-.89,7.43L14.66,23a1,1,0,0,1,.71,0l6.72,3.18Z",
  transform: "translate(-1 -1.63)",
  style: {
    fill: "#fff800"
  }
}));
export default SvgStarEmpty;